<script setup lang="ts">
import type { HTMLAttributes } from 'vue';
import { cn } from '../ui-utils.ts';

const props = defineProps<{
  class?: HTMLAttributes['class'];
}>();
</script>

<template>
  <ul
    data-sidebar="menu-badge"
    :class="
      cn(
        'mx-3.5 flex min-w-0 translate-x-px flex-col gap-1 border-l-2 border-white/30 px-2.5 py-0.5 backdrop-blur-xs',
        'group-data-[collapsible=icon]:hidden',
        props.class,
      )
    "
  >
    <slot />
  </ul>
</template>
